import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router';
import { useDispatch } from 'react-redux';
import { CssBaseline } from '@material-ui/core';

import indexRoutes from './routes/main';
import { appInit } from './store/modules/init/actions';
import { DeferredActionContext, useDeferredActionContext } from './services/common/DeferredActionContext';

const App = () => {
  const dispatch = useDispatch();
  const deferredContext = useDeferredActionContext();

  useEffect(() => {
    dispatch(appInit());
  }, [dispatch]);

  return (
    <DeferredActionContext.Provider value={deferredContext}>
      <CssBaseline />
      <Switch>
        {indexRoutes.map((route) => (
          <Route
            key={Array.isArray(route.path) ? route.path.join(';') : route.path}
            {...route}
          />
        ))}
      </Switch>
    </DeferredActionContext.Provider>
  );
};

export default App;
